import { Network, enums, helpers } from '@kattana-io/common';

const decoratePriceAlertStatus = (status: string) => {
  switch (status) {
  case enums.PriceAlertStatus.WATCH:
    return 'OPEN';
  case enums.PriceAlertStatus.FIRED:
    return 'NOTIFIED';
  case enums.PriceAlertStatus.CONSUMED:
    return 'COMPLETED';
  default:
    return status;
  }
};

const decorateLimitOrderStatus = (status: string) => {
  switch (status) {
  case enums.LimitOrderStatus.WATCH:
    return 'OPEN';
  case enums.LimitOrderStatus.CONSUMED:
    return 'COMPLETED';
  case enums.LimitOrderStatus.FIRED:
    return 'FILLED';
  default:
    return status;
  }
};

const decorateExchangeName = (exchange: string, chain: string = '') => {
  switch (exchange) {
  case 'maiar':
    return 'xExchange';
  case 'okxdex':
    return 'OKC DEX';
  case helpers.exchanges.OKX:
    return 'OKX';
  case 'ORPHAN':
    return `${
      Network.isValidChain(chain)
        ? Network.fromChain(chain).getTitle()
        : chain
    }-dex`;
  default:
    return exchange;
  }
};

const decorateCexHistoryOrderStatus = (status: number) => {
  switch (status) {
  case 1:
    return 'OPEN';
  case 2:
    return 'FILLED';
  case 3:
    return 'PARTIALLY FILLED';
  case 4:
    return 'CANCELLED';
  case 5:
    return 'PARTIALLY CANCELLED';
  case 6:
    return 'FAILED';
  default:
    return 'UNKNOWN';
  }
};

const decorateSwapType = (type: enums.SwapType) => {
  switch (type) {
  case enums.SwapType.DIRECT_SWAP:
    return 'Direct Swap';
  case enums.SwapType.PAIR_SWAP:
    return 'Pair Swap';
  case enums.SwapType.PROXY_DIRECT_SWAP:
    return 'Limit Direct Swap';
  case enums.SwapType.PROXY_PAIR_SWAP:
    return 'Limit Pair Swap';
  default:
    return '-';
  }
};

export {
  decoratePriceAlertStatus,
  decorateLimitOrderStatus,
  decorateExchangeName,
  decorateCexHistoryOrderStatus,
  decorateSwapType,
};
